import { Component } from '@angular/core';

@Component({
  selector: 'app-not-active',
  templateUrl: './not-active.component.html',
  styleUrls: ['./not-active.component.css']
})
export class NotActiveComponent {

}
